var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimulateDropup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5316 17.0306C21.4619 17.1005 21.3792 17.1559 21.2881 17.1937C21.1969 17.2315 21.0993 17.251 21.0006 17.251C20.902 17.251 20.8043 17.2315 20.7132 17.1937C20.622 17.1559 20.5393 17.1005 20.4696 17.0306L12.0006 8.56013L3.53161 17.0306C3.46188 17.1004 3.3791 17.1557 3.28799 17.1934C3.19688 17.2312 3.09923 17.2506 3.00061 17.2506C2.902 17.2506 2.80435 17.2312 2.71324 17.1934C2.62213 17.1557 2.53934 17.1004 2.46961 17.0306C2.39988 16.9609 2.34457 16.8781 2.30683 16.787C2.26909 16.6959 2.24967 16.5983 2.24967 16.4996C2.24967 16.401 2.26909 16.3034 2.30683 16.2123C2.34457 16.1212 2.39988 16.0384 2.46961 15.9686L11.4696 6.96864C11.5393 6.89879 11.622 6.84338 11.7132 6.80557C11.8043 6.76776 11.902 6.74829 12.0006 6.74829C12.0993 6.74829 12.1969 6.76776 12.2881 6.80557C12.3792 6.84338 12.4619 6.89879 12.5316 6.96864L21.5316 15.9686C21.6015 16.0383 21.6569 16.1211 21.6947 16.2122C21.7325 16.3033 21.752 16.401 21.752 16.4996C21.752 16.5983 21.7325 16.696 21.6947 16.7871C21.6569 16.8782 21.6015 16.961 21.5316 17.0306Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimulateDropup);
export default __webpack_public_path__ + "static/media/simulate_dropup.87575edb9e2164c61f7962728a88c79c.svg";
export { ForwardRef as ReactComponent };